import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { documentsService } from "../services/documents.services"
import { buildContentService } from "../services/build_content.services"
import axiosClient from "axios"
import axios from "../services/axios"
import { clearMultibase } from "../actions/multiAiBase"

import { CHANGE_PASSWORD, DELETE_ANNOTATION_FAILED, GET_NOTIFICATION, UPDATE_NOTIFICATION } from "../types/index"

import {
	changePassword,
	changePasswordFailed,
	changePasswordSuccess,
	getNotificationFailed,
	getNotificationSuccess,
	updateNotificationFailed,
	updateNotificationSuccess,
} from "../actions/headerActions"
import { setNotification } from "../actions/notificationActions"

const getNotification = async () => {
	return await axios.get(`/notifications?retrive_count=30&skip_count=0&status=all`).catch((e) => console.log(e))
}

const updateNotification = async (data) => {
	return await axios.put(`/notifications`, data).catch((e) => console.log(e))
}

const changePasswordAPI = async (data) => {
	return await axios.post(`/user/change_password`, data).catch((e) => console.log(e))
}

function* getNotificationFlow(action) {
	try {
		const result = yield call(getNotification, action?.payload)

		if (result?.status === 200) {
			yield put(getNotificationSuccess(result?.data)) //update store
		} else {
			yield put(getNotificationFailed(result))
		}
	} catch (error) {
		yield put(getNotificationFailed(error))
	}
}

function* updateAnnotationFlow(action) {
	try {
		const result = yield call(updateNotification, action?.payload)
		if (result?.status === 200) {
			try {
				const result = yield call(getNotification, action?.payload)

				if (result?.status === 200) {
					yield put(getNotificationSuccess(result?.data)) //update store
				} else {
					yield put(getNotificationFailed(result))
				}
			} catch (error) {
				yield put(getNotificationFailed(error))
			}
		} else {
			yield put(updateNotificationFailed(result))
		}
	} catch (error) {
		yield put(updateNotificationFailed(error))
	}
}

function* changePasswordFlow(action) {
	try {
		const result = yield call(changePasswordAPI, action?.payload)
		if (result?.status === 200 && result?.data?.success) {
			yield put(changePasswordSuccess(result?.data))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(changePasswordFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message || "something went wrong",
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(changePasswordFailed(error))
		yield put(
			setNotification({
				data: error?.message || "something went wrong",
				severity: "error",
			})
		)
	}
}

function* viewerWatcher() {
	yield takeLatest(GET_NOTIFICATION, getNotificationFlow)
	yield takeLatest(UPDATE_NOTIFICATION, updateAnnotationFlow)
	yield takeLatest(CHANGE_PASSWORD, changePasswordFlow)
}

export default viewerWatcher
